import { schema } from 'normalizr';

import api from '../utils/axiosClient';
import createResource from './createResource';

const url = '/settings';
const entitiesKey = 'settings';

// Schemas
const settingsSchema = new schema.Entity(
  entitiesKey,
  {},
  {
    idAttribute: (_, { setting, _id }) => setting || _id,
  },
);

const settingsResource = createResource({
  key: entitiesKey,
  url,
  schemaDefinition: settingsSchema,
});

// Methods
async function save({ id, data }: any) {
  return api.put(
    `${url}/${id}`,
    {
      settings: data,
    },
    {
      // @ts-ignore
      schema: { settings: settingsSchema },
    },
  );
}

export default {
  ...settingsResource,
  entitiesKey,
  settingsSchema,
  save,
};
